import { GapCursorSelection } from '../selection';
export function setGapCursorSelection(view, pos, side) {
  var state = view.state;
  view.dispatch(state.tr.setSelection(new GapCursorSelection(state.doc.resolve(pos), side)));
}